/* RANTY · Sugeridos del carro. Combina recomendaciones complementarias/relacionadas de Shopify
   (hasta 3 productos del carro, el ultimo agregado primero) y la coleccion de respaldo.
   Se re-ejecuta solo: el drawer vuelve a dibujar <ranty-cart-recs> al agregar/quitar/cambiar cantidades. */
if (!customElements.get('ranty-cart-recs')) {
  customElements.define('ranty-cart-recs', class RantyCartRecs extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      var slot = this.querySelector('.ranty-recs__slot');
      var pids = (this.dataset.pids || this.dataset.product || '').split(',').filter(Boolean).slice(0, 3);
      if (!slot || !pids.length) return;
      this._loaded = true;
      var self = this;
      var base = this.dataset.url;
      var root = this.dataset.root || '/';
      var n = parseInt(this.dataset.count, 10) || 3;
      var mode = this.dataset.mode || 'complementary';

      function cards(url) {
        return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          if (!html) return [];
          var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.ranty-rc-list');
          if (!list) return [];
          return Array.prototype.map.call(list.children, function (el) { return { id: el.getAttribute('data-pid'), html: el.outerHTML }; });
        }).catch(function () { return []; });
      }
      function recs(pid, intent) {
        return cards(base + '?section_id=ranty-cart-recs&product_id=' + encodeURIComponent(pid) + '&limit=10&intent=' + intent);
      }
      function fallback() { return cards(root + '?section_id=ranty-cart-recs'); }
      function roundRobin(lists) {
        var out = [], i = 0, more = true;
        while (more) {
          more = false;
          lists.forEach(function (l) { if (l[i]) { out.push(l[i]); more = true; } });
          i++;
        }
        return out;
      }
      var seen = {}, out = [];
      function add(list, max) {
        var added = 0;
        list.forEach(function (c) {
          if (out.length >= n || (max && added >= max) || !c.id || seen[c.id]) return;
          seen[c.id] = 1; out.push(c); added++;
        });
      }
      function intent(i) { return Promise.all(pids.map(function (p) { return recs(p, i); })).then(roundRobin); }

      var steps;
      if (mode === 'collection') {
        steps = [fallback, function () { return intent('complementary'); }, function () { return intent('related'); }];
      } else if (mode === 'shopify') {
        steps = [function () { return intent('related'); }, function () { return intent('complementary'); }, fallback];
      } else if (mode === 'mix') {
        steps = [function () { return intent('complementary').then(function (l) { return l.slice(0, 1); }); }, fallback,
          function () { return intent('complementary'); }, function () { return intent('related'); }];
      } else {
        steps = [function () { return intent('complementary'); }, function () { return intent('related'); }, fallback];
      }
      steps.reduce(function (p, step) {
        return p.then(function () { return out.length >= n ? null : step().then(function (l) { add(l); }); });
      }, Promise.resolve()).then(function () {
        if (out.length) {
          slot.innerHTML = out.map(function (c) { return c.html; }).join('');
          self.hidden = false;
        }
      });
    }
  });
}
